var React = require('react');

function ChefHatInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m90.397 38.606c2.9 2.667 4.434 6.051 4.6 10.15.1 4-1.2 7.467-3.9 10.4-2.733 3-6.083 4.566-10.05 4.699-2.6.101-4.933-.35-7-1.35-.066-.066-.117-.083-.15-.05l-.05.05-37.4-34.55c-.034-.066-.083-.134-.15-.2-1.133-2.8-1.716-5.45-1.75-7.95-.2-4.066 1.1-7.6 3.9-10.6 2.7-2.9 6.083-4.434 10.15-4.601 3.967-.166 7.433 1.134 10.4 3.9 2.267 2.1 3.733 4.566 4.4 7.4 1.133-.334 2.383-.534 3.75-.601 4-.2 7.5 1.101 10.5 3.9 2.934 2.7 4.483 6.083 4.65 10.149.1 1.867-.167 3.65-.8 5.351 3.334.204 6.3 1.504 8.9 3.903zm-38.799 47.101-37.35-34.55 19.5-20.65 37.3 34.8zm-2.9 2.899-6.5 6.801-37.2-34.4 6.35-6.9z","fillRule":"evenodd"}));
}

ChefHatInline.defaultProps = {"enableBackground":"new 0 0 100 100","viewBox":"0 0 100 100"};

module.exports = ChefHatInline;

ChefHatInline.default = ChefHatInline;
